@use '@design/design-tokens/typography/typography' as *;

.logoBadge {
  position: absolute;
  right: -4px;
  bottom: -4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 2px;
  border-radius: 100px;
  background-color: var(--background-soft);
}

.secondaryText {
  display: flex;
  align-items: center;
  gap: 4px;
  @include typography-v2-body-xs;
}

.trackingStatus {
  color: var(--text-soft);

  &.isTracking {
    color: var(--viz-bullish);
  }
}

.horizon {
  color: var(--text-soft);
}

.assetNameText {
  @include typography-v2-body-xs;
  color: var(--text-default);

  &.read {
    color: var(--text-soft);
  }

  &.compact {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 240px;
  }

}

.secondaryAssetInfoText {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}
